import Spinner from 'styleguide/Spinner/Spinner';
import View from 'styleguide/View/View';
import useLegalStepWithApplicationId from './useLegalStepWithApplicationId';

export default function LegalStepWithApplicationId() {
	useLegalStepWithApplicationId();

	return (
		<View
			style={{
				display: 'flex',
				justifyContent: 'center',
				alignItems: 'center',
				width: '500px',
				height: '600px',
			}}
		>
			<Spinner width="96px" height="96px" />
		</View>
	);
}
